export const validateForm = {
  required: 'Это поле необходимо заполнить',
  phone: 'Некорректный формат номера телефона',
  email: 'Неверный формат Email',
  birthday: 'Укажите дату в формате дд-мм-гггг',
  bonusCard: 'Укажите номер карты цифрами',
  bonusCard2: 'Номер состоит из 7 или 13 цифр',
  phoneCode: 'Код состоит из 4-х символов',
}
